import labels from "emun.order/_labels";
import templateUrl from "emun.salesrep/product-sales.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";

export class ProductSalesController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.labels = labels;
    $ctrl.productImage = $ctrl.$appConfig.productImage.bind($ctrl.$appConfig);

    var url =
      "QuerySalesDailyProductTotals.json?Sum=SalesDailyTotal,SalesDailyCaseQtyCount&GroupBy=ProductID,ProductDescription&dateRange=YTD&CustomOrderBy=SalesDailyOrderTotal";
    var lyurl =
      "QuerySalesDailyProductTotals.json?Sum=SalesDailyTotal,SalesDailyCaseQtyCount&GroupBy=ProductID,ProductDescription&dateRange=LYTD&CustomOrderBy=SalesDailyOrderTotal&CompareYear=true";

    if ($ctrl.customerId && $ctrl.customerId != null) {
      url =
        "QuerySalesDailyCustomerProductTotals.json?Sum=SalesDailyTotal,SalesDailyCaseQtyCount&GroupBy=ProductID,ProductDescription&dateRange=YTD&CustomerId=" +
        $ctrl.customerId;
      lyurl =
        "QuerySalesDailyCustomerProductTotals.json?Sum=SalesDailyTotal,SalesDailyCaseQtyCount&GroupBy=ProductID,ProductDescription&dateRange=LYTD&CustomerId=" +
        $ctrl.customerId;
    }
    if ($ctrl.categoryId) {
      url = url + "&CategoryID=" + $ctrl.categoryId;
      lyurl = lyurl + "&CategoryID=" + $ctrl.categoryId;
    }
    var context = $ctrl.context || "rep";
    var filterType = "SalesRepID";
    var repFilter = "";
    if (
      context !== "executive" &&
      context !== "customer" &&
      $ctrl.customerId == null
    ) {
      if (context === "manager") {
        filterType = "ManagerId";
      }
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
      url = url + repFilter;
      lyurl = lyurl + repFilter;
    }
    var totalProduct = {
      ProductID: "",
      Description: "",
      YTD: 0,
      YTDCount: 0,
      LYTD: 0,
      LYTDCount: 0,
    };
    $ctrl.topProducts = [];
    this.topProductsytd = new AutoQuery({
      url: url,
      autoLoad: true,
      pageSize: 100,
      take: 100,
      onLoaded: function (ytdtotals) {
        this.topProductsly = new AutoQuery({
          url: lyurl,
          autoLoad: true,
          pageSize: 100,
          take: 100,
          onLoaded: function (lytotals) {
            ytdtotals.results.forEach(function (ytdtotals) {
              //console.info("ytdtotals", ytdtotals.productID, ytdtotals.sumSalesDailyTotal);
              var totalProduct = [];
              totalProduct.ProductID = ytdtotals.productID;
              totalProduct.Description = ytdtotals.productDescription;
              totalProduct.YTD = ytdtotals.sumSalesDailyTotal;
              totalProduct.YTDCount = ytdtotals.sumSalesDailyCaseQtyCount;

              lytotals.results.forEach(function (c) {
                if (c.productID === ytdtotals.productID) {
                  //console.info("c.productID", c.productID, c.sumSalesDailyTotal);
                  totalProduct.LYTD = c.sumSalesDailyTotal;
                  totalProduct.LYTDCount = c.sumSalesDailyCaseQtyCount;
                }
              });

              $ctrl.topProducts.push(totalProduct);
            });
            //console.info("$ctrl.topProducts", $ctrl.topProducts);
          },
        });
      },
    });
  }

  downloadData() {
    let $ctrl = this;
    var url = $ctrl.$appConfig.resolveServiceUrl(
      $ctrl.topProducts.url.replace(".json", ".csv")
    );
    return (location.href = url);
  }
}

export default {
  bindings: {
    rep: "<",
    categoryId: "@",
    context: "@",
    customerId: "@",
  },
  controller: ProductSalesController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
